import React, { useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Download, Mail, Loader2, User } from 'lucide-react';
import { trackResourceLead } from '../lib/analytics';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const CaminoDownloadGate = ({ cfg, onDownloaded }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const clean = email.trim().toLowerCase();
    if (!EMAIL_RE.test(clean)) { setError('Escribe un email válido para recibir el PDF.'); return; }
    setError('');
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/camino/${cfg.slug}/download`, { email: clean, name: name.trim() || null });
    } catch (_) { /* download must never be blocked by tracking */ }
    const a = document.createElement('a');
    a.href = cfg.pdf; a.download = ''; a.rel = 'noopener';
    document.body.appendChild(a); a.click(); a.remove();
    setLoading(false);
    trackResourceLead(`camino_${cfg.slug}`);
    onDownloaded(clean);
  };

  return (
    <motion.form
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      data-testid={`camino-gate-${cfg.slug}`}
      className="max-w-2xl mx-auto mt-6 mb-6 rounded-2xl bg-white border border-black/5 shadow-lg p-5"
    >
      <p className="font-extrabold text-base text-[#2F2F2F]">Descarga gratis la infografía en PDF</p>
      <p className="mt-1 text-sm text-gray-600 leading-relaxed">
        Déjame tu email y te llevas el PDF para el Camino. Sin spam: sólo frases y trucos de español de vez en cuando.
      </p>
      <div className="mt-4 space-y-3">
        <label className="flex items-center gap-2 rounded-xl border border-gray-200 px-3 py-2.5 focus-within:border-[#7DBDD9]">
          <User className="w-4 h-4 text-gray-400 flex-shrink-0" />
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Tu nombre (opcional)"
            data-testid="camino-gate-name"
            className="w-full text-sm outline-none bg-transparent text-[#2F2F2F] placeholder:text-gray-400"
          />
        </label>
        <label className="flex items-center gap-2 rounded-xl border border-gray-200 px-3 py-2.5 focus-within:border-[#7DBDD9]">
          <Mail className="w-4 h-4 text-gray-400 flex-shrink-0" />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@email.com"
            required
            inputMode="email"
            autoComplete="email"
            data-testid="camino-gate-email"
            className="w-full text-sm outline-none bg-transparent text-[#2F2F2F] placeholder:text-gray-400"
          />
        </label>
        {error && <p className="text-xs text-[#E38987] font-semibold" data-testid="camino-gate-error">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          data-testid={`camino-download-${cfg.slug}`}
          className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-white font-bold text-base shadow-lg active:scale-95 transition-transform disabled:opacity-70"
          style={{ background: `linear-gradient(90deg, ${cfg.accent}, #7DBDD9)` }}
        >
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Download className="w-5 h-5" />}
          Descargar PDF
        </button>
        <p className="text-[11px] text-gray-400 text-center">
          Tu email sólo se usa para enviarte contenido de Spanisch en la Red. Puedes darte de baja cuando quieras.
        </p>
      </div>
    </motion.form>
  );
};
